import { LocaleEnum } from '@systemeio/ui'

export const replaceHelpHref = (href: string, locale: LocaleEnum) =>
  href === `${window.location.origin}/help`
    ? locale === LocaleEnum.ENGLISH
      ? href
      : `${window.location.origin}/${locale}/help`
    : href
